<template>
  <b-card>
    <!-- media -->
    <b-media no-body>
      <b-media-aside>
        <b-link>
           <b-avatar
              size="40"
              variant="light-primary"
              badge
              class="badge-minimal"
              badge-variant="success"
            >
              <feather-icon icon="UserIcon" size="22" />
            </b-avatar>
        </b-link>
      </b-media-aside>
    </b-media>
    <!--/ media -->

    <!-- form -->
    <b-form class="mt-2">
      <b-row>
        <b-col sm="6">
          <b-form-group
            label="First name"
            label-for="account-username"
          >
            <b-form-input
              v-model="optionsLocal.firstName"
              placeholder="First name"
              name="username"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="Last name"
            label-for="account-last-name"
          >
            <b-form-input
              v-model="optionsLocal.lastName"
              name="account-last-ame"
              placeholder="Last name"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="E-mail" label-for="account-e-mail">
            <b-form-input
              v-model="optionsLocal.email"
              name="email"
              placeholder="Email"
            />
          </b-form-group>
        </b-col>
        <!-- <b-col sm="6">
          <b-form-group label="Company" label-for="account-company">
            <b-form-input
              v-model="optionsLocal.company"
              name="company"
              placeholder="Company name"
            />
          </b-form-group>
        </b-col> -->

        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="saveSettings()"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import axios from "axios";

import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BImg,
  BAvatar
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BAvatar,
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
    },
  },
  data() {
    return {
      optionsLocal: JSON.parse(JSON.stringify(this.generalData)),
    };
  },
  methods: {
    resetForm() {
      this.optionsLocal = JSON.parse(JSON.stringify(this.generalData));
    },
    saveSettings() {
      console.log(this.optionsLocal);
      axios
        .put(
          `https://mtl-feeder-nodejs.onrender.com/api/users/${
            JSON.parse(localStorage.getItem("userData"))._id
          }`,
          this.optionsLocal
        )
        .then((response) => {
          console.log(response);
          // response.data.user.admin = response.data
          var newData ={  
            "_id":response.data.user._id,
            "email":response.data.user.email,
            "username":response.data.user.username,
            "role":"admin",
            "admin":{"_id":response.data._id,
                      "firstName":response.data.firstName,
                      "lastName":response.data.lastName,
                      "user":response.data._id
                      }
            }
          localStorage.setItem("userData", JSON.stringify(newData))
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `User updated`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Error during update`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
  },
  setup() {
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl);

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    };
  },
};
</script>
